import React from 'react';
import './home.css'
import Headerr from '../components/layout/header';
import Navbar from '../components/layout/navbar';
import Sec1myticket from '../sections/sec1-myticket';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';

const Myticket = () => {
                      const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />
    return ( 
        <>
            <main className='home-background'>

                    <Headerr />
                        <Sec1myticket />
                    <Navbar />

            </main>
        </>
     );
}
 
export default Myticket;